// src/services/userService.js
import api from './api';

const BASE = '/users';

const userService = {
  list: (params) =>
    api.get(BASE, { params: { functionCode: 'USER_VIEW', ...params } })
       .then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'USER_VIEW' } })
       .then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'USER_CREATE' })
       .then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'USER_UPDATE' })
       .then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'USER_DELETE' } })
       .then(r => r.data),
};

export default userService;
